// Images for the About Us page
export const aboutUsHeroImage = "/assets/jpg/Aboutus1.jpg";
export const aboutUsHistoryImage = "/assets/jpg/Aboutus2.jpg";
export const aboutUsVisionImage = "/assets/jpg/Aboutus3.jpg";
export const aboutUsSharePageImage = "/assets/jpg/Aboutus4.jpg";

// Social media icons
export const facebookIcon = "/assets/svg/facebook.svg";
export const twitterIcon = "/assets/svg/twitter.svg";
export const instagramIcon = "/assets/svg/instagram.svg";
export const linkedinIcon = "/assets/svg/linkedin.svg";
export const xIcon = "/assets/svg/x.svg";
export const coins = "/assets/svg/noun-document.svg";

// Document and UI icons
export const downloadIcon = "/assets/svg/download.svg";
export const documentIcon = "/assets/svg/document.svg";
export const rightArrowIcon = "/assets/svg/arrow-right.svg";
